import React from 'react';
import classnames from 'classnames';
import s from './FeedSidebar.scss';
var FeedSidebar = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement("div", null, children)));
};
FeedSidebar.displayName = 'FeedSidebar';
export default FeedSidebar;
//# sourceMappingURL=FeedSidebar.js.map